import { numberToPrettyString, plural } from '@cian/utils';

export function prettyPluralize(number: number, variants: [string, string, string]): string {
  return `${numberToPrettyString(number)} ${plural(number, variants)}`;
}
